import React from "react";
import { Box, BoxProps, Button, Flex, Input, Text } from "@chakra-ui/react";
import { landing } from "../../landingTokens";
import { useLandingTheme } from "../../LandingThemeContext";

function UploadIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M10 13V4m0 0L6.5 7.5M10 4l3.5 3.5M4 13.5V15a1.5 1.5 0 001.5 1.5h9A1.5 1.5 0 0016 15v-1.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// One control: a single bar that takes a pasted link, with the upload button as its trailing segment.
export function UploadBar({ onDark = false, showHelperText = true, ...props }: BoxProps & { onDark?: boolean; showHelperText?: boolean }) {
  const theme = useLandingTheme();
  const barBg = onDark ? "rgba(255, 255, 255, 0.08)" : theme.color.inputBg;
  const barBorder = onDark ? "1px solid rgba(255, 255, 255, 0.18)" : `1px solid ${theme.color.border}`;
  const textColor = onDark ? "#FFFFFF" : theme.color.inputText;
  const placeholderColor = onDark ? "rgba(255, 255, 255, 0.55)" : theme.color.muted;
  return (
    <Box w="100%" {...props}>
      <Flex align="center" bg={barBg} border={barBorder} borderRadius={theme.shape.buttonRadius} p="6px" pl="18px" h="64px" boxShadow={theme.button.shadow === "none" ? "none" : undefined}>
        <Input
          variant="unstyled"
          placeholder="Paste a link or drop a file"
          fontFamily={theme.font.body}
          fontSize="15px"
          color={textColor}
          _placeholder={{ color: placeholderColor }}
          minW={0}
        />
        <Button
          flexShrink={0}
          h="100%"
          px="22px"
          bg={theme.color.accent}
          color={theme.button.primaryColor}
          border={theme.button.border}
          fontFamily={theme.font.body}
          fontSize="16px"
          fontWeight={600}
          borderRadius={theme.shape.buttonRadius === "999px" ? "999px" : `calc(${theme.shape.buttonRadius} - 3px)`}
          leftIcon={<UploadIcon />}
          iconSpacing="8px"
          transition={landing.buttonHoverTransition}
          _hover={{ bg: theme.color.accentHover }}
          _focusVisible={{ boxShadow: `0 0 0 3px ${theme.color.highlight}` }}
        >
          Upload
        </Button>
      </Flex>
      {showHelperText && (
        <Text mt="12px" fontFamily={theme.font.body} fontSize="14px" color={placeholderColor} lineHeight={1.5}>
          Works with lecture slides, PDFs, YouTube videos, textbooks, webpages and notes. Free to start.
        </Text>
      )}
    </Box>
  );
}
